"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "comune-test": {
    "centro-storico": [{
      "levelFrom": 10,
      "levelTo": 11,
      "slugLevelParent": "centro",
      "hkey": "a325069c",
      "slug": "centro-storico",
      "name": "Centro Storico",
      "primary": true
    }],
    "zona-vecchia": [{
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null,
      "hkey": "a325069c",
      "slug": "nuovo-comune",
      "name": "Nuovo Comune",
      "primary": true
    }],
    "quartiere-vecchissimo": [{
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": null,
      "hkey": "a325069c",
      "slug": "quartiere-nuovo",
      "name": "quartiere-nuovo",
      "primary": true
    }],
    "quartiere-stra-vecchissimo": [{
      "levelFrom": 11,
      "levelTo": 10,
      "slugLevelParent": null,
      "hkey": "a325069c",
      "slug": "zona-nuova",
      "name": "zona-nuova",
      "primary": true
    }],
    "quartiere-stra-vecchio": [{
      "levelFrom": 11,
      "levelTo": 11,
      "slugLevelParent": "zona-nuovissima",
      "hkey": "a325069c",
      "slug": "quartiere-nuovo",
      "name": "quartiere-nuovo",
      "primary": true
    }]
  }
};
exports["default"] = _default;